import { Identifiable, Planzone, ProjectStatus } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveProjectStatus(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Planzone>, status: ProjectStatus) =>
    httpClient.sendHttpRequest<Identifiable<ProjectStatus>>({
      endpoint: "/projectStatuses",
      method: HttpMethods.POST,
      data: { ...status, planzone: `/planzones/${uuid}` },
    });
}

export { saveProjectStatus };
